<template lang="pug">
  help-dialog(:show="visible" @close="visible = false")
    h5 {{$t('management_page.remote_and_connection_maintenance_policy')}}
    p {{$t('management_page.remote_and_connection_policy_applies_to_all')}}
    ul
      li
        .tit {{$t('management_page.remote_control_file_transfer')}}
        .txt-1 {{$t('management_page.block_remote_control_file_transfer')}}
        .txt-2 {{$t('management_page.block_applies_to_all_users')}}
        .txt-1 {{$t('management_page.allow_user_permissions')}}
        .txt-2 {{$t('management_page.allow_transition_no_access')}}
      li
        .tit {{$t('management_page.system_user_bulk_apply')}}
        .txt-2 {{$t('management_page.screen_capture_recording_lock')}}
        .txt-2 {{$t('management_page.screen_saver_power_saving')}}
        .txt-2 {{$t('management_page.forced_idle_logout_manager')}}
        .txt-2 {{$t('management_page.forced_idle_termination_viewer')}}
</template>

<script>
import HelpDialog from "@/components/mixins/dialog/help.vue"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HelpDialog,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
    }
  },
}
</script>

<style lang="scss" scoped src="./dialog.scss"></style>
